uniform float uTime;
uniform vec3 colorStart;
uniform vec3 colorEnd;
varying float vPositionAlongLine;

// Precompute constants
const float TIME_SCALE = 0.15;
const float POSITION_SCALE = 0.0125; // 1.0/80.0 precomputed
const float ALPHA = 0.70;
const float SMOOTHSTEP_MIN = 0.4;
const float SMOOTHSTEP_MAX = 1.0;
const float SMOOTHSTEP_RANGE = 0.6; // 1.0 - 0.4

void main() {
    // Single calculation combining time and position effects
    float runEffect = abs(sin(uTime * TIME_SCALE - vPositionAlongLine * POSITION_SCALE));
    
    // Optimized smoothstep - avoid division by precomputing range
    float t = clamp((runEffect - SMOOTHSTEP_MIN) / SMOOTHSTEP_RANGE, 0.0, 1.0);
    // Apply smoothstep curve manually (more efficient than built-in smoothstep)
    t = t * t * (3.0 - 2.0 * t);
    
    // Mix colors and output
    vec3 color = mix(colorStart, colorEnd, t);
    gl_FragColor = vec4(color, ALPHA);
}
